'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface BlogFiltersProps {
  selectedCategory: string;
  searchQuery: string;
  onCategoryChange: (category: string) => void;
  onSearchChange: (query: string) => void;
}

const categories = [
  { value: 'all', label: 'All Posts' },
  { value: 'puppy-care', label: 'Puppy Care' },
  { value: 'training', label: 'Training' },
  { value: 'health', label: 'Health' },
  { value: 'breed-info', label: 'Breed Information' },
  { value: 'nutrition', label: 'Nutrition' },
];

const BlogFilters = ({
  selectedCategory,
  searchQuery,
  onCategoryChange,
  onSearchChange,
}: BlogFiltersProps) => {
  return (
    <div className="mb-8 rounded-xl bg-card p-6 shadow-warm">
      <div className="mb-5 flex items-center gap-3">
        <Icon name="FunnelIcon" size={24} variant="outline" className="text-primary" />
        <h3 className="font-heading text-lg font-semibold text-foreground">
          Filter Articles
        </h3>
      </div>

      <div className="grid gap-5 md:grid-cols-2">
        <div>
          <label
            htmlFor="search"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Search Articles
          </label>
          <div className="relative">
            <Icon
              name="MagnifyingGlassIcon"
              size={20}
              variant="outline"
              className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              id="search"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by keyword..."
              className="w-full rounded-md border border-border bg-input py-2.5 pl-12 pr-4 text-foreground transition-smooth placeholder:text-muted-foreground hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
            />
          </div>
        </div>

        <div>
          <label
            htmlFor="category"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Category
          </label>
          <select
            id="category"
            value={selectedCategory}
            onChange={(e) => onCategoryChange(e.target.value)}
            className="w-full rounded-md border border-border bg-input px-4 py-2.5 text-foreground transition-smooth hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          >
            {categories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default BlogFilters;